module.exports = __webpack_public_path__ + "img/sintesis.f219ee25.svg";